<app-header></app-header>
<app-banner></app-banner>
<app-about-text></app-about-text>
<app-block-cta></app-block-cta>
<app-services></app-services>
<app-products></app-products>
<app-team></app-team>
<div class="section secondary-overlay bg-center bg-cover pt-0" [style.background-image]="'url(assets/img/bg1.jpg)'">
    <div class="spacer white-bg spacer-lg d-none d-lg-block"></div>
    <div class="container">
        <app-video></app-video>
        <app-counter></app-counter>
    </div>
</div>
<app-testimonials></app-testimonials>
<app-contact-block></app-contact-block>
<app-blogs></app-blogs>
<div class="section border-top">
    <app-clients></app-clients>
</div>
<app-footer></app-footer>